'use strict';

module.exports = [

    '$filter', 'main.fechaConfig',

    function (filter, fechaConfig) {
        return function (input) {

            if (input === null) { return null; }

            return filter('date')(Moment(input).format(fechaConfig.FORMATO_FECHA.toUpperCase()));
        };
    }
];



// WEBPACK FOOTER //
// ./src/busqueda/filtros/fecha.filter.js